'use client';

import { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

const INTENT_DELAY_MS = 25;

interface IPrefetchIntent {
  prefetch: true | undefined,
  startIntent: () => void,
  cancelIntent: () => void,
}

// Debounced: a pointer sweep across links doesn't prefetch, only a pause over one does.
const usePrefetchIntent = (): IPrefetchIntent => {
  const [isIntent, setIsIntent] = useState(false);

  const { startIntent, cancelIntent } = useMemo(() => {
    const debouncedStart = debounce(() => setIsIntent(true), INTENT_DELAY_MS);

    return {
      startIntent: debouncedStart,
      cancelIntent: (): void => {
        debouncedStart.cancel();
        setIsIntent(false);
      },
    };
  }, []);

  return { prefetch: isIntent || undefined, startIntent, cancelIntent };
};

export default usePrefetchIntent;
